import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { SlideIn } from "@faire/retailer-visitor-shared/components/SlideIn";
import { getTotalBrandCount, getTotalCitiesCount } from "@faire/retailer-visitor-shared/lib/getMarketingCount";
import { ContentContainer, FieldBackground } from "@faire/retailer-visitor-shared/views/about/components/common";
import { MapModule } from "@faire/retailer-visitor-shared/views/about/components/MapModule";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled, { css } from "styled-components";
export var NumberModule = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useViewport = useViewport(), isMobile = _useViewport.isMobile, isDesktopAndAbove = _useViewport.isDesktopAndAbove;
    var valueProps = [
        {
            largeText: strictLocalize({
                id: "kJHwIj",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Millions of products"
                    }
                ]
            }),
            smallText: strictLocalize({
                id: "DIoB04",
                defaultMessage: [
                    {
                        type: 0,
                        value: "sold each year"
                    }
                ]
            })
        },
        {
            largeText: strictLocalize({
                id: "AseMYF",
                defaultMessage: [
                    {
                        type: 1,
                        value: "makerCount"
                    },
                    {
                        type: 0,
                        value: " brands"
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                makerCount: getTotalBrandCount()
            })),
            smallText: strictLocalize({
                id: "7ibZjQ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "selling on Faire"
                    }
                ]
            })
        },
        {
            largeText: strictLocalize({
                id: "b4p4WP",
                defaultMessage: [
                    {
                        type: 1,
                        value: "cityNumber"
                    },
                    {
                        type: 0,
                        value: " cities"
                    }
                ]
            }, {
                cityNumber: getTotalCitiesCount()
            }),
            smallText: strictLocalize({
                id: "No8MJx",
                defaultMessage: [
                    {
                        type: 0,
                        value: "with Faire retailers"
                    }
                ]
            })
        },
        {
            largeText: isMobile ? strictLocalize({
                id: "ug8/rD",
                defaultMessage: [
                    {
                        type: 0,
                        value: "7M connections"
                    }
                ]
            }) : strictLocalize({
                id: "lPwFwl",
                defaultMessage: [
                    {
                        type: 0,
                        value: "7 million connections"
                    }
                ]
            }),
            smallText: strictLocalize({
                id: "pBAtn1",
                defaultMessage: [
                    {
                        type: 0,
                        value: "introduced on Faire"
                    }
                ]
            })
        }
    ];
    return /*#__PURE__*/ _jsx(FieldBackground, {
        children: /*#__PURE__*/ _jsx(ContentContainer, {
            align: "center",
            children: /*#__PURE__*/ _jsxs(Row, {
                children: [
                    /*#__PURE__*/ _jsx(Wrapper, {
                        children: valueProps.map(function(value, index) {
                            return /*#__PURE__*/ _jsx(Row, {
                                align: isMobile ? "center" : "flex-start",
                                children: /*#__PURE__*/ _jsx(StyledColumn, {
                                    align: isMobile ? "center" : "flex-start",
                                    children: /*#__PURE__*/ _jsxs(SlideIn, {
                                        offset: "".concat(30 + index * 20, "px"),
                                        children: [
                                            /*#__PURE__*/ _jsx(LargeText, {
                                                $overflow: value.largeText.length > 25,
                                                variant: {
                                                    mobileAndAbove: "displaySSerifRegular",
                                                    tabletAndAbove: "displayMSerifRegular"
                                                },
                                                color: Core.text.inverse,
                                                children: value.largeText
                                            }),
                                            /*#__PURE__*/ _jsx(Spacer, {
                                                height: "1x"
                                            }),
                                            /*#__PURE__*/ _jsx(Typography, {
                                                variant: "subheadingSansRegular",
                                                color: Core.text.inverse,
                                                align: isMobile ? "center" : "unset",
                                                children: value.smallText
                                            }),
                                            index !== valueProps.length - 1 ? /*#__PURE__*/ _jsx(Spacer, {
                                                height: "5x"
                                            }) : null
                                        ]
                                    })
                                })
                            }, index);
                        })
                    }),
                    isDesktopAndAbove ? /*#__PURE__*/ _jsx(MapModule, {}) : null
                ]
            })
        })
    });
};
var Wrapper = styled.div.withConfig({
    componentId: "sc-9eb29702-0"
})([
    "display:grid;grid-template-columns:1fr;",
    "{padding:80px 0;}",
    "{column-gap:64px;grid-template-columns:1fr 1fr;padding:88px 0;}",
    "{padding:128px 0;}",
    "{padding:184px 0;}"
], responsiveMediaQueries.mobile, responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktop, responsiveMediaQueries.xLargeAndAbove);
var StyledColumn = styled(Column).withConfig({
    componentId: "sc-9eb29702-1"
})([
    "",
    "{width:100%;}"
], responsiveMediaQueries.mobile);
var LargeText = styled(Typography).withConfig({
    componentId: "sc-9eb29702-2"
})([
    "",
    "{",
    "}"
], responsiveMediaQueries.tabletAndAbove, function(props) {
    return !props.$overflow ? css([
        "max-width:200px;"
    ]) : css([
        "width:270px;"
    ]);
});
